<template>
<div class="mediaBlock">
    <div class="mediaBlock-media">
        <img v-if="item.image" :src="item.image" :alt="item.imageAltText" :srcset="item.imageSrcSet" :sizes="item.imageSizes">
    </div>
    <div class="mediaBlock-copy mediaBlock-copy_verticalCenter">
        <div class="richTextCard">
            <div class="richTextCard-hdg">
                <h3 class="hdg hdg_3">{{item.headline}}</h3>
            </div>
            <div class="richTextCard-richtext">
                <div class="quarantineContent" v-html="item.summary">
                </div>
            </div>
            <div v-if="item.readMoreLink">
                <a :href="item.readMoreLink" class="iconCta">
                    <div class="iconCta-text">{{readMoreCopy}}</div>
                    <div class="iconCta-icon">
                        <i class="icon icon_chevron"></i>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  props: ["item", "readMoreCopy"]
};
</script>
